module.exports = __webpack_public_path__ + "static/img/g-bg-two.3b854e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-eight/g-bg-two.png
// module id = C577
// module chunks = 0